
// src/reducers/attachments-reducer.js

import { 
  FETCH_CHAT_IMAGES_VIEW,
  FETCH_GROUP_TIMELINE_ATTACHMENTS,
  FETCH_IMAGES_VIEW_REQUESTED,
  FETCH_IMAGES_VIEW_COMPLETED,
  FETCH_IMAGES_VIEW_FAILED,
  CLEAR_IMAGES_VIEW,
} from '../actions/images-view'

const initialState = {
  isFetching: false,
  isFetchFailed: false,
  items: undefined,
}

export default function imagesViewReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_IMAGES_VIEW_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
      isFetchFailed: false,
    })

  case FETCH_IMAGES_VIEW_COMPLETED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: false,
      items: action.results,
    })

  case FETCH_IMAGES_VIEW_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
      isFetchFailed: true,
    })

  case CLEAR_IMAGES_VIEW:
    return Object.assign({}, state, {
      isFetching: false,
      items: undefined
    })

  default:
    return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/images-view-reducer.js